@if (!hasSavedPreferences()) {
  <aside
    class="cookie-banner"
    [attr.aria-label]="translate.getTranslation('cookieConsent.banner.title')"
  >
    <span class="cookie-banner__icon" aria-hidden="true">
      <img src="/icons/cookie-consent.svg" alt="" />
    </span>
    <div class="cookie-banner__content">
      <p class="cookie-banner__title">
        {{ translate.getTranslation('cookieConsent.banner.title') }}
      </p>
      <p class="cookie-banner__description">
        {{ translate.getTranslation('cookieConsent.banner.descriptionBeforeLink') }}
        <button (click)="openPolicy()">
          {{ translate.getTranslation('cookieConsent.banner.policyLink') }}</button
        >.
        {{ translate.getTranslation('cookieConsent.banner.descriptionAfterLink') }}
      </p>
    </div>
    <div class="cookie-banner__actions">
      <button class="button button--secondary" (click)="openSettings()">
        {{ translate.getTranslation('cookieConsent.banner.manageSettings') }}
      </button>
      <button class="button button--primary" (click)="acceptAll()">
        {{ translate.getTranslation('cookieConsent.banner.acceptAll') }}
      </button>
    </div>
  </aside>
}

@if (dialog()) {
  <div class="cookie-overlay">
    <button
      class="cookie-overlay__backdrop"
      [attr.aria-label]="translate.getTranslation('cookieConsent.closeDialog')"
      (click)="closeDialog()"
    ></button>
    <section
      class="cookie-dialog"
      [class.cookie-dialog--policy]="dialog() === 'policy'"
      aria-modal="true"
      role="dialog"
    >
      @if (dialog() === 'policy') {
        <header class="cookie-dialog__header">
          <div>
            <h2>{{ translate.getTranslation('cookieConsent.policy.title') }}</h2>
            <p>
              <strong>{{ translate.getTranslation('cookieConsent.policy.lastUpdated') }}</strong>
              {{ translate.getTranslation('cookieConsent.policy.lastUpdatedDate') }}
            </p>
          </div>
          <button
            class="cookie-dialog__close"
            [attr.aria-label]="translate.getTranslation('cookieConsent.policy.closeLabel')"
            (click)="closeDialog()"
          >
            ×
          </button>
        </header>
        <div class="cookie-dialog__content">
          <p>{{ translate.getTranslation('cookieConsent.policy.introFirst') }}</p>
          <p>{{ translate.getTranslation('cookieConsent.policy.introSecond') }}</p>
          <h3>{{ translate.getTranslation('cookieConsent.policy.definitionsTitle') }}</h3>
          <h4>{{ translate.getTranslation('cookieConsent.policy.interpretationTitle') }}</h4>
          <p>{{ translate.getTranslation('cookieConsent.policy.interpretation') }}</p>
          <h4>{{ translate.getTranslation('cookieConsent.policy.definitionsSubtitle') }}</h4>
          <p>{{ translate.getTranslation('cookieConsent.policy.definitionsIntro') }}</p>
          <ul>
            <li>{{ translate.getTranslation('cookieConsent.policy.company') }}</li>
            <li>{{ translate.getTranslation('cookieConsent.policy.cookies') }}</li>
            <li>{{ translate.getTranslation('cookieConsent.policy.website') }}</li>
          </ul>
          <h3>{{ translate.getTranslation('cookieConsent.policy.useTitle') }}</h3>
          <h4>{{ translate.getTranslation('cookieConsent.policy.typesTitle') }}</h4>
          <p>{{ translate.getTranslation('cookieConsent.policy.types') }}</p>
          <h3>{{ translate.getTranslation('cookieConsent.policy.choicesTitle') }}</h3>
          <p>{{ translate.getTranslation('cookieConsent.policy.choices') }}</p>
          <h3>{{ translate.getTranslation('cookieConsent.policy.changesTitle') }}</h3>
          <p>{{ translate.getTranslation('cookieConsent.policy.changes') }}</p>
          <h3>{{ translate.getTranslation('cookieConsent.policy.contactTitle') }}</h3>
          <p>
            {{ translate.getTranslation('cookieConsent.policy.contact') }}
            <a href="mailto:support@retailtech.com">support&#64;retailtech.com</a>.
          </p>
        </div>
        <footer class="cookie-dialog__actions">
          <button class="button button--secondary" (click)="openSettings()">
            {{ translate.getTranslation('cookieConsent.policy.manageSettings') }}
          </button>
          <button class="button button--primary" (click)="acceptAll()">
            {{ translate.getTranslation('cookieConsent.policy.acceptAll') }}
          </button>
        </footer>
      } @else {
        <header class="cookie-dialog__header">
          <h2>{{ translate.getTranslation('cookieConsent.settings.title') }}</h2>
          <button
            class="cookie-dialog__close"
            [attr.aria-label]="translate.getTranslation('cookieConsent.settings.closeLabel')"
            (click)="closeDialog()"
          >
            ×
          </button>
        </header>
        <div class="cookie-settings">
          <section class="cookie-settings__item">
            <div>
              <h3>{{ translate.getTranslation('cookieConsent.settings.necessaryTitle') }}</h3>
              <p>{{ translate.getTranslation('cookieConsent.settings.necessaryDescription') }}</p>
            </div>
            <strong>{{ translate.getTranslation('cookieConsent.settings.alwaysActive') }}</strong>
          </section>
          <section class="cookie-settings__item">
            <div>
              <h3>{{ translate.getTranslation('cookieConsent.settings.performanceTitle') }}</h3>
              <p>{{ translate.getTranslation('cookieConsent.settings.performanceDescription') }}</p>
            </div>
            <input
              type="checkbox"
              [checked]="draft().performance"
              [attr.aria-label]="
                translate.getTranslation('cookieConsent.settings.performanceLabel')
              "
              (change)="updatePreference('performance', $event)"
            />
          </section>
          <section class="cookie-settings__item">
            <div>
              <h3>{{ translate.getTranslation('cookieConsent.settings.functionalTitle') }}</h3>
              <p>{{ translate.getTranslation('cookieConsent.settings.functionalDescription') }}</p>
            </div>
            <input
              type="checkbox"
              [checked]="draft().functional"
              [attr.aria-label]="translate.getTranslation('cookieConsent.settings.functionalLabel')"
              (change)="updatePreference('functional', $event)"
            />
          </section>
          <section class="cookie-settings__item">
            <div>
              <h3>{{ translate.getTranslation('cookieConsent.settings.targetingTitle') }}</h3>
              <p>{{ translate.getTranslation('cookieConsent.settings.targetingDescription') }}</p>
            </div>
            <input
              type="checkbox"
              [checked]="draft().targeting"
              [attr.aria-label]="translate.getTranslation('cookieConsent.settings.targetingLabel')"
              (change)="updatePreference('targeting', $event)"
            />
          </section>
        </div>
        <footer class="cookie-dialog__actions">
          <button class="button button--secondary" (click)="confirmChoices()">
            {{ translate.getTranslation('cookieConsent.settings.confirmChoices') }}
          </button>
          <button class="button button--primary" (click)="acceptAll()">
            {{ translate.getTranslation('cookieConsent.settings.acceptAll') }}
          </button>
        </footer>
      }
    </section>
  </div>
}
